// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3aRu-","error":"Textarea_error__a69NI","readonly":"Textarea_readonly__3es8o","disabled":"Textarea_disabled__snlmG"};